export default __webpack_public_path__ + "static/media/linux.d7f0206b.svg";